<template>
  <div
    v-if="!$data.$_ssDD_processing"
    class="oct-salon-dashboard"
  >
    <section class="oct-salon-dashboard-summary">
      <!-- Sent Style Count -->
      <div class="oct-salon-dashboard-summary-item">
        <span class="oct-salon-dashboard-summary-item__label">
          スタイル送信数

          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
            <path d="M2.01562 1.76562V14.2356L13.9956 8.00064L2.01562 1.76562ZM3.51562 8.75064H6.51562V7.25064H3.51562V4.23563L10.7456 8.00064L3.51562 11.7656V8.75064Z"/>
          </svg>
        </span>

        <span class="oct-salon-dashboard-summary-item__value">{{ $_ssDD_sentStyleCount }}</span>
      </div>

      <!-- Unique Customer Count -->
      <div class="oct-salon-dashboard-summary-item">
        <span class="oct-salon-dashboard-summary-item__label">
          ユニーク顧客数

          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
            <path d="M14.4922 13.1265C14.1968 11.3535 12.46 8 8.00244 8C3.54492 8 1.80811 11.3535 1.5127 13.1265L1.36719 14H14.6377L14.4922 13.1265ZM3.26416 12.5C3.74023 11.3545 4.97827 9.5 8.00244 9.5C11.0266 9.5 12.2646 11.3545 12.7407 12.5H3.26416Z"/>
            <path d="M8 7.25C9.51636 7.25 10.75 6.01611 10.75 4.5C10.75 2.98364 9.51636 1.75 8 1.75C6.48364 1.75 5.25 2.98364 5.25 4.5C5.25 6.01611 6.48364 7.25 8 7.25ZM8 3.25C8.68921 3.25 9.25 3.81055 9.25 4.5C9.25 5.18945 8.68921 5.75 8 5.75C7.31079 5.75 6.75 5.18945 6.75 4.5C6.75 3.81055 7.31079 3.25 8 3.25Z"/>
          </svg>
        </span>

        <span class="oct-salon-dashboard-summary-item__value">{{ $data.$_ssDD_summary.customerCount }}</span>
      </div>

      <!-- Viewed Style Count -->
      <div class="oct-salon-dashboard-summary-item">
        <span class="oct-salon-dashboard-summary-item__label">
          スタイル閲覧数

          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
            <path d="M10 2H6C2.69 2 0 4.69 0 8C0 11.31 2.69 14 6 14H10C13.31 14 16 11.31 16 8C16 4.69 13.31 2 10 2ZM10.12 10.12C9.555 10.685 8.8 11 8 11C7.2 11 6.445 10.69 5.88 10.12C5.315 9.555 5 8.8 5 8C5 7.2 5.31 6.445 5.88 5.88C6.445 5.315 7.2 5 8 5C8.8 5 9.555 5.31 10.12 5.88C10.685 6.445 11 7.2 11 8C11 8.8 10.69 9.555 10.12 10.12Z" />
            <path d="M9.06 6.94C8.775 6.655 8.4 6.5 8 6.5C7.6 6.5 7.225 6.655 6.94 6.94C6.655 7.225 6.5 7.6 6.5 8C6.5 8.4 6.655 8.775 6.94 9.06C7.505 9.625 8.495 9.625 9.06 9.06C9.345 8.775 9.5 8.4 9.5 8C9.5 7.6 9.345 7.225 9.06 6.94Z" />
          </svg>
        </span>

        <span class="oct-salon-dashboard-summary-item__value">{{ $_ssDD_viewedStyleCount }}</span>
      </div>

      <!-- Added To Cart Count -->
      <div class="oct-salon-dashboard-summary-item">
        <span class="oct-salon-dashboard-summary-item__label">
          カート追加数

          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
            <path d="M10.75 5.25V4.25C10.75 2.73499 9.51501 1.5 8 1.5C6.48499 1.5 5.25 2.73499 5.25 4.25V5.25H2V14H14V5.25H10.75ZM6.75 4.25C6.75 3.56 7.31 3 8 3C8.69 3 9.25 3.56 9.25 4.25V5.25H6.75V4.25ZM12.5 12.5H3.5V6.75H5.25V8.25H6.75V6.75H9.25V8.25H10.75V6.75H12.5V12.5Z" />
          </svg>
        </span>

        <span class="oct-salon-dashboard-summary-item__value">{{ $_ssDD_addedToCartCount }}</span>
      </div>

      <!-- Purchase Count -->
      <div class="oct-salon-dashboard-summary-item">
        <span class="oct-salon-dashboard-summary-item__label">
          購入件数

          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
            <path d="M1.5 3V13H14.5V3H1.5ZM3 4.5H13V6.25H3V4.5ZM13 11.5H3V7.75H13V11.5Z" />
          </svg>
        </span>

        <span class="oct-salon-dashboard-summary-item__value">{{ $_ssDD_purchaseCount }}</span>
      </div>

      <!-- Sales Amount -->
      <div class="oct-salon-dashboard-summary-item">
        <span class="oct-salon-dashboard-summary-item__label">
          売上金額

          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
            <path d="M9.5603 7.25031H12.0003V8.75031H8.75031V10.2503H12.0003V11.7503H8.75031V14.0003H7.25031V11.7503H4.00031V10.2503H7.25031V8.75031H4.00031V7.25031H6.44031L2.94531 2.88528L4.1153 1.94531L8.00031 6.80029L11.8853 1.94531L13.0553 2.88528L9.5603 7.25031Z" />
          </svg>
        </span>

        <span class="oct-salon-dashboard-summary-item__value">{{ $_ssDD_formatCurrency($_ssDD_salesAmount) }}</span>
      </div>
    </section>

    <section class="oct-salon-dashboard-trend">
      <div class="oct-salon-dashboard-header">
        <h2 class="oct-salon-dashboard-header__primary-text">
          トレンド
        </h2>

        <p class="oct-salon-dashboard-header__secondary-text">
          スタイル送信数・閲覧数・購入数の推移
        </p>
      </div>

      <div class="oct-salon-dashboard-trend-chart">
        <div class="oct-salon-dashboard-trend-chart-summary">
          <div class="oct-salon-dashboard-trend-chart-summary-item">
            <span class="oct-salon-dashboard-trend-chart-summary-item__label">スタイル送信数</span>
            <span class="oct-salon-dashboard-trend-chart-summary-item__value">{{ $_ssDD_sentStyleCount }}</span>
          </div>

          <div class="oct-salon-dashboard-trend-chart-summary-item">
            <span class="oct-salon-dashboard-trend-chart-summary-item__label">閲覧数</span>
            <span class="oct-salon-dashboard-trend-chart-summary-item__value">{{ $_ssDD_viewedStyleCount }}</span>
          </div>

          <div class="oct-salon-dashboard-trend-chart-summary-item">
            <span class="oct-salon-dashboard-trend-chart-summary-item__label">購入件数</span>
            <span class="oct-salon-dashboard-trend-chart-summary-item__value">{{ $_ssDD_purchaseCount }}</span>
          </div>
        </div>

        <!-- Chart -->
        <div class="oct-salon-dashboard-trend-chart__container">
          <SSDashboardChart
            :labels="$_ssDD_trendChartData.labels"
            :sentCounts="$_ssDD_trendChartData.sentStyleCounts"
            :viewedCounts="$_ssDD_trendChartData.viewedStyleCounts"
            :purchasedCounts="$_ssDD_trendChartData.purchaseCounts"
          />
        </div>
      </div>
    </section>

    <!-- Staff Performance -->
    <section class="oct-salon-dashboard-staff-performance">
      <!-- Header -->
      <div class="oct-salon-dashboard-header">
        <h2 class="oct-salon-dashboard-header__primary-text">
          スタッフ別パフォーマンス
        </h2>

        <p class="oct-salon-dashboard-header__secondary-text">
          スタッフごとの送信数・閲覧数・売上
        </p>
      </div>

      <!-- Staff List -->
      <div class="oct-salon-dashboard-staff-performance__container">
        <div class="oct-salon-dashboard-staff-performance__slider">
          <SSDashboardStaffList
            :items="$data.$_ssDD_summary.staffs"
            class="oct-salon-dashboard-staff-performance__list"
          />
        </div>

        <!-- Inset Shadow (only when horizontal overflow / scroll is possible) -->
        <div class="oct-salon-dashboard-staff-performance__shadow" />
      </div>
    </section>

    <!-- Child routes -->
    <transition :name="transitionName">
      <router-view />
    </transition>
  </div>

  <div v-else>
    <!-- Child routes -->
    <transition :name="transitionName">
      <router-view />
    </transition>
  </div>

</template>

<script>
import { getExecutionEnvironment } from '@/plugins/AppConfig';
import API from '@/api/index.js';
import UsageMapper from './UsageMapper.js';
import DashboardQueryService from '@/core/infrastructure/DashboardQueryService';
import SSDashboardChart from '@/components/dashboard-chart/SSDashboardChart.vue';
import SSDashboardStaffList from '@/components/dashboard-staff-list/SSDashboardStaffList.vue';

export default {
  name: 'OctSalonDashboard',
  components: {
    SSDashboardChart,
    SSDashboardStaffList,
  },
  props: {
    salonId: {
      type: String,
      default: '',
    },
    startDate: {
      type: String,
      default: '',
    },
    endDate: {
      type: String,
      default: '',
    },
  },
  data() {  
    return {
      /**
       * Aggregated salon dashboard metrics for the selected date range, in the same shape as
       * `DashboardQueryService.getSummary`. Replaced when `$_ssDD_update` completes successfully.
       *
       * @type {{
       *   customerCount: number,
       *   granularity?: string,
       *   usages: Array<{
       *     startDate: string,
       *     metrics: {
       *       sentStyleCount: number,
       *       customerCount: number,
       *       viewedStyleCount: number,
       *       addedToCartCount: number,
       *       purchaseCount: number,
       *       salesAmount: number,
       *     },
       *   }>,
       *   staffs: Array<{
       *     name: string,
       *     role: number,
       *     performance: {
       *       sentStyleCount: number,
       *       viewedStyleCount: number,
       *       favoritedStyleCount: number,
       *       addedToCartCount: number,
       *       purchasedCount: number,
       *       purchasedCustomerCount: number,
       *       salesAmount: number,
       *     },
       *   }>,
       * }}
       */
      $_ssDD_summary: {
        customerCount: 0,
        usages: [],
        staffs: [],
      },
      /** @type {DashboardQueryService|null} */
      $_ssDD_dashboardQueryService: null,
      /**
       * Indicate processing
       * @type {boolean}
       * @default false
       */
      $_ssDD_processing: false,
    };
  },
  computed: {
    /**
     * Chart data for the trend chart.
     *
     * @returns {Object} Chart data.
     */
    $_ssDD_trendChartData() {
      return UsageMapper.toChartData(this.$data.$_ssDD_summary.usages);
    },
    /**
     * Stable key combining `startDate` and `endDate` so a single watcher can
     * refetch when either changes, without double-firing when both update in one tick.
     */
    $_ssDD_dateRangeKey() {
      return `${this.startDate}|${this.endDate}`;
    },
    /**
     * Total sent-style count across all time buckets in `$_ssDD_summary.usages`.
     *
     * @returns {number}
     */
    $_ssDD_sentStyleCount() {
      return this.$data.$_ssDD_summary.usages.reduce((acc, usage) => acc + usage.metrics.sentStyleCount, 0);
    },
    /**
     * Total viewed-style count across all usage buckets.
     *
     * @returns {number}
     */
    $_ssDD_viewedStyleCount() {
      return this.$data.$_ssDD_summary.usages.reduce((acc, usage) => acc + usage.metrics.viewedStyleCount, 0);
    },
    /**
     * Total add-to-cart events across all usage buckets.
     *
     * @returns {number}
     */
    $_ssDD_addedToCartCount() {
      return this.$data.$_ssDD_summary.usages.reduce((acc, usage) => acc + usage.metrics.addedToCartCount, 0);
    },
    /**
     * Total purchase count across all usage buckets.
     *
     * @returns {number}
     */
    $_ssDD_purchaseCount() {
      return this.$data.$_ssDD_summary.usages.reduce((acc, usage) => acc + usage.metrics.purchaseCount, 0);
    },
    /**
     * Total sales amount (JPY) summed across all usage buckets.
     *
     * @returns {number}
     */
    $_ssDD_salesAmount() {
      return this.$data.$_ssDD_summary.usages.reduce((acc, usage) => acc + usage.metrics.salesAmount, 0);
    },
    /** Transition name */
    transitionName: vm => vm.$store.state.session.history.action,
  },
  methods: {
    /**
     * Loads aggregated dashboard metrics for the current `salonId` and date range into
     * `$_ssDD_summary`. Skips when `$_ssDD_processing` is already true. Dispatches a global
     * alert on failure. Always clears `$_ssDD_processing` in `finally`.
     *
     * @async
     * @returns {Promise<void>}
     */
    async $_ssDD_update() {
      if (this.$data.$_ssDD_processing) return;

      try {
        this.$data.$_ssDD_summary = await this.$_ssDD_fetchSummary(
          this.$data.$_ssDD_dashboardQueryService,
          this.salonId,
          this.startDate,
          this.endDate,
        );
      } catch (error) {
        console.error(error);
        this.$store.dispatch('alert', 'ダッシュボード情報を取得できませんでした');
      } finally {
        this.$data.$_ssDD_processing = false;
      }
    },
    /**
     * Delegates to `DashboardQueryService.getSummary` for the given salon and date range.
     *
     * @async
     * @param {DashboardQueryService} queryService Service instance (must be non-null for a real request).
     * @param {string} salonId Target salon identifier.
     * @param {string} startDate Range start (`YYYY-MM-DD`).
     * @param {string} endDate Range end (`YYYY-MM-DD`).
     * @returns {Promise<Object>} Summary payload (same shape as `$_ssDD_summary` after assign).
     */
    async $_ssDD_fetchSummary(queryService, salonId, startDate, endDate) {
      const from = new Date(startDate);
      const to = new Date(endDate);
      const diffDays = Math.ceil((to - from) / (1000 * 60 * 60 * 24));

      return await queryService.getSummary(
        salonId,
        startDate,
        endDate,
        diffDays > 60 ? 'month' : diffDays > 14 ? 'week' : 'day',
      );
    },
    /**
     * Format a sales amount as a Japanese yen currency string.
     * @param {number} value - Value to format.
     * @returns {string} Localized currency string (e.g. "￥344,740").
     */
    $_ssDD_formatCurrency(value) {
      return value.toLocaleString('ja-JP', { style: 'currency', currency: 'JPY' });
    },
  },
  mounted() {
    this.$data.$_ssDD_dashboardQueryService = new DashboardQueryService(
      this.$appConfig().apiBase,
      getExecutionEnvironment().isProduction() ? API.getAccessToken() : null,
    );

    this.$_ssDD_update();
  },
  watch: {
    $_ssDD_dateRangeKey: {
      handler() {
        this.$_ssDD_update();
      },
    },
  },
}
</script>

<style scoped lang="scss">
@import "../theme/variables";
@import "../grid/variables";
@import "../typography/variables";
@import "../typography/mixins";

.oct-salon-dashboard {
  display: flex;
  flex-direction: column;
  gap: oct-rem(64);
}

.oct-salon-dashboard-summary {
  display: grid;
  grid-template-columns: repeat(auto-fit, oct-rem(202));
  gap: oct-rem(16);

@media screen and (min-width: oct-rem(1280)) {
  grid-template-columns: repeat(6, 1fr);
}
}

.oct-salon-dashboard-summary-item {
  display: flex;
  flex-direction: column;
  gap: oct-rem(16);
  padding: oct-rem(16);
  border: oct-rem(1) solid $oct-theme--neutral-20;
}

.oct-salon-dashboard-summary-item__label {
  font-size: oct-rem(12);
  line-height: 1;
  color: $oct-theme--neutral-50;
  display: flex;
  align-items: center;
  gap: oct-rem(8);

  svg {
    fill: $oct-theme--neutral-50;
    width: oct-rem(16);
    height: oct-rem(16);
  }
}

.oct-salon-dashboard-summary-item__value {
  font-size: oct-rem(20);
  font-weight: 600;
  line-height: 1;
}

.oct-salon-dashboard-summary-item__meta {
  display: flex;
  flex-direction: column;
  gap: oct-rem(4);
}

.oct-salon-dashboard-summary-item__caption {
  font-size: oct-rem(10);
  line-height: 1;
  color: $oct-theme--neutral-50;
}

.oct-salon-dashboard-header {
  display: flex;
  flex-direction: column;
  gap: oct-rem(16);
}

.oct-salon-dashboard-header__primary-text {
  font-size: oct-rem(20);
  font-weight: 600;
  line-height: 1;
  margin: 0;
}

.oct-salon-dashboard-header__secondary-text {
  font-size: oct-rem(14);
  line-height: 1;
  color: $oct-theme--neutral-50;
  margin: 0;
}

.oct-salon-dashboard-trend {
  display: flex;
  flex-direction: column;
  gap: oct-rem(32);
}

.oct-salon-dashboard-trend-chart {
  display: flex;
  flex-direction: column;
  gap: oct-rem(48);
  padding: oct-rem(32) 0 oct-rem(16);
  border: oct-rem(1) solid $oct-theme--neutral-20;
}

.oct-salon-dashboard-trend-chart-summary {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: oct-rem(16);
}

.oct-salon-dashboard-trend-chart-summary-item {
  display: flex;
  flex-direction: column;
  gap: oct-rem(8);
  padding: 0 oct-rem(16);
}

.oct-salon-dashboard-trend-chart-summary-item__label {
  font-size: oct-rem(12);
  line-height: 1;
  color: $oct-theme--neutral-50;
}

.oct-salon-dashboard-trend-chart-summary-item__value {
  font-size: oct-rem(20);
  font-weight: 600;
  line-height: 1;
}

.oct-salon-dashboard-staff-performance {
  display: flex;
  flex-direction: column;
  gap: oct-rem(32);
}

.oct-salon-dashboard-staff-performance__container {
  position: relative;
}

.oct-salon-dashboard-staff-performance__slider {
  overflow-x: auto;

@media screen and (min-width: oct-rem(1024+128)) {
  overflow-x: visible;
}
}

.oct-salon-dashboard-staff-performance__list  {
  min-width: oct-rem(1024);

@media screen and (min-width: oct-rem(1024+128)) {
  ::v-deep thead {
    position: sticky;
    left: 0;
    top: oct-rem(120);
    background-color: $oct-theme--surface;
  }
}
}

.oct-salon-dashboard-staff-performance__shadow {
  position: absolute;
  top: 0;
  right: 0;
  width: oct-rem(32);
  height: 100%;
  background-color: rgba(255, 255, 255, 0.00);
  box-shadow: -20px 0 20px -16px rgba(0, 0, 0, 0.10) inset;

@media screen and (min-width: oct-rem(1024+128)) {
  display: none;
}
}

.oct-salon-dashboard-trend-chart__container {
  width: 100%;
  height: oct-rem(216);
  padding: 0 oct-rem(16);
}

/** Override transform settings */
.oct-salon-dashboard > .oct-dialog {
  /** Property and duration settings duaring transition */
  &.forward-enter-active, &.forward-leave-active, &.back-enter-active, &.back-leave-active {
    overflow: hidden;

    &::v-deep {
      & > .oct-dialog__container {
        height: 100%;
        overflow: hidden;
        transition: transform .5s;
      }
    }
  }

  &--center {
    /** Transition starting/ending point settings */
    &.forward-enter, &.back-leave-to, &.forward-leave-to, &.back-enter {
      &::v-deep {
        & > .oct-dialog__container {
          transform: translateY(100%);
        }
      }
    }
  }

  &--right {
    /** Transition starting/ending point settings */
    &.forward-enter, &.back-leave-to, &.forward-leave-to, &.back-enter {
      &::v-deep {
        & > .oct-dialog__container {
          transform: translateX(100%);
        }
      }
    }
  }

  &--left {
    /** Transition starting/ending point settings */
    &.forward-enter, &.back-leave-to, &.forward-leave-to, &.back-enter {
      &::v-deep {
        & > .oct-dialog__container {
          transform: translateX(-100%);
        }
      }
    }
  }

  /** Transition starting/ending point settings */
  &.forward-enter, &.back-leave-to, &.forward-leave-to, &.back-enter {
    &::v-deep {
      & > .oct-dialog__container > .oct-dialog__surface {
        transform: none;
      }
    }
  }

  &.forward-leave-to, &.back-enter {
    &::v-deep {
      & > .oct-dialog__container > .oct-dialog__surface {
        transform: none;
      }
    }
  }
}
</style>